import { ToastUtilities } from "@libs/react-toastify/ToastUtilities";
import { IFileDataFields, TFileDataFields } from "@propely/propely-typings";
import { getFunctions, httpsCallable } from "firebase/functions";
import { FirebaseDataExternalReference } from "../Property/Units/FirebaseDataExternalReference";
import { ExternalFileMetadata } from "./DataObjectHelpers/FileDocumentDataHelper/FileDocumentDataHelperUtilities";
import { FileDocumentData } from "./FileDocumentData";
import { RelativeData } from "./RelativeData";

export class PropertyFileData extends FileDocumentData {
  relatives: RelativeData[] = [];
  archived: boolean = false;

  externalFileClientID: string = "";
  externalFileMetadata: ExternalFileMetadata = {};
  externalRefs: { [key: string]: FirebaseDataExternalReference } = {};

  dataFields: IFileDataFields = {};

  setup(data: any) {
    this.relatives = [];
    if (typeof data.relatives === "object") {
      for (const relativeID of Object.keys(data.relatives)) {
        this.relatives.push(new RelativeData(relativeID, data.relatives[relativeID]));
      }
    }

    this.archived = typeof data.archived === "boolean" ? data.archived : false;
    this.externalFileClientID = data.externalFileClientID || "";

    if (typeof data.externalFileMetadata === "object") {
      this.externalFileMetadata = {
        propertyID: data.externalFileMetadata.propertyID || "",
      };
    }
    if (typeof data.externalRefs === "object") {
      this.externalRefs = {};
      for (const apiClientID of Object.keys(data.externalRefs)) {
        this.externalRefs[apiClientID] = {
          id: typeof data.externalRefs[apiClientID].id === "string" ? data.externalRefs[apiClientID].id : "",
          apiClientID: apiClientID,
        };
      }
    }

    const parsedDataFields = TFileDataFields.safeParse(data.dataFields);
    if (parsedDataFields.success) {
      this.dataFields = parsedDataFields.data;
    }

    super.setup(data);
  }

  archive() {
    const newArchiveStatus = !this.archived;
    return this.saveUpdate({ archived: newArchiveStatus }).then(() => {
      this.archived = newArchiveStatus;
    });
  }
  override loadFileURL(callback: () => void): void {
    if (!this.externalFileClientID) {
      super.loadFileURL(callback);
    } else {
      this.fileLoadedListeners.push(callback);
      this.fileLoading = true;

      const functions = getFunctions(undefined, "europe-west1");
      const getExternalFileURL = httpsCallable(functions, "getExternalFileURL");

      getExternalFileURL({
        propertyID: this.parent?.id,
        fileID: this.id,
      })
        .then((response) => {
          if (typeof response.data === "string") {
            this.externalURL = response.data;
          }
        })
        .catch((error) => {
          ToastUtilities.presentServerError(error);
        })
        .finally(() => {
          this.fileLoading = false;
          this.fileLoaded = true;
          for (const listener of this.fileLoadedListeners) {
            listener();
          }
        });
    }
  }

  getExternalLink(): { name: string; url: string } | undefined {
    if (this.externalFileClientID === "findable" && this.externalRefs.findable?.id && this.externalFileMetadata.propertyID) {
      return {
        name: "Findable",
        url: `https://app.findable.no/buildings/${this.externalFileMetadata.propertyID}/?documentId=${this.externalRefs.findable.id}`,
      };
    }
  }
}
